import { render, staticRenderFns } from "./category-popup.vue?vue&type=template&id=5d98da75&scoped=true&"
import script from "./category-popup.vue?vue&type=script&lang=js&"
export * from "./category-popup.vue?vue&type=script&lang=js&"
import style0 from "./category-popup.vue?vue&type=style&index=0&id=5d98da75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d98da75",
  null
  
)

export default component.exports